import React, { useEffect, useRef, useState } from "react";
import { Table, Tooltip, Col, Form, Input, Tabs, Row } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import ImageUploading from "react-images-uploading";
import { DownloadOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import moment from "moment";
import { URL } from "../../Redux/common/url";
import Select from "react-select";
import TabPane from "antd/lib/tabs/TabPane";
import SchemeWisePdfPlot from "../Product/SchemeWisePdfPlot";
import Api from "../../Redux/common/api";
import ReactToPrint from "react-to-print";
function SchemeDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const users_list = useSelector((state) =>
    state?.allapi?.get_sub_category ? state?.allapi?.get_sub_category : {}
  );
  const get_main_all_category = useSelector((state) =>
    state?.allapi?.get_main_all_category
      ? state?.allapi?.get_main_all_category
      : []
  );

  console.log(users_list);

  const listdata = users_list?.docs ? users_list?.docs : [];

  const [subList, setsubList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const dropList = get_main_all_category?.map((data, i) => {
      data.value = data?._id;
      data.label = data?.name;

      return data;
    });

    setsubList(dropList);
  }, [get_main_all_category]);

  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const [showDelelt, setShowDelete] = useState(false);

  const handleCloseDelete = () => setShowDelete(false);
  const [cateID, setcateID] = useState("");

  const hendleDelete = async (e) => {
    console.log(e);
    // deleteProduct
    await dispatch(
      allapiAction.deleteDocuments({ productId: e, pageNo: page })
    );
    setShowDelete(false);
    getDate();
    // dispatch(allapiAction.deletesubCategory({ productId: e, pageNo: page }));

    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };


  const hendleDelete8 = async (e) => {
    console.log(e);
    // deleteProduct

    

    await dispatch(
      allapiAction.deleteCategory({ productId: e, pageNo: page })
    );
    setShowDelete(false);
    getDate();
    // dispatch(allapiAction.deletesubCategory({ productId: e, pageNo: page }));

    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addModalOpen1, setAddModalOpen1] = useState(false);
  const [addModalOpen2, setAddModalOpen2] = useState(false);
  const [addModalOpen7, setAddModalOpen7] = useState(false);
  const [addModalOpen3, setAddModalOpen3] = useState(false);

  const hendleModalShow = (e) => {
    // setShowDelete(true)
    setcateID(e);
    setIsModalOpen(true);
  };

  const [cateDetail, setcateDetail] = useState({});
  const [cateDetail1, setcateDetail1] = useState({});
  const [cateDetail3, setcateDetail3] = useState({});

  console.log(cateDetail);

  const [images, setImages] = useState([]);
  const maxNumber = 1;

  console.log(images);

  const [Imagesfe, setImagesfe] = useState("");

  const onChangefe = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex)
    setImagesfe(imageList);
  };

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  const [selectedOptionUpdate, setSelectedOptionUpdate] = useState(null);

  const hendleTochangeCategory = (e) => {
    const { name, value } = e.target;
    setcateDetail({ ...cateDetail, [name]: value });
  };
  const hendleTochangeCategory3 = (e) => {
    const { name, value } = e.target;
    setcateDetail3({ ...cateDetail3, [name]: value });
  };

  const showModal = (e) => {
    console.log(e);
    setcateDetail(e);
    const selectCate = subList.find((edata) => edata?._id == e?.parentId?._id);

    setSelectedOptionUpdate(selectCate);
    setImagesfe([{ data_url: URL.API_BASE_URL + e.image }]);
    setIsModalOpen(true);
  };

  const handleOkAddDocument = async () => {
    if (!cateDetail2s?.images) {
      toast.error("please select document");
    } else if (cateDetail2s?.images?.length == 0) {
      toast.error("please select document");
    } /* else if (!cateDetailAdd?.rasidNo) {
        toast.error("please enter recept No");
      } */ else {
      const data = new FormData();
      // data.append("page", 1);
      data.append("schemeId", id);
      console.log(cateDetail2?.images);
      console.log(selectedFiles);
      console.log(cateDetail2?.images?.FileList);

      for (let i = 0; i < selectedFiles?.length; i++) {
        data.append("images", selectedFiles[i]);
      }

      const response = await dispatch(allapiAction.propertyDocumentAdd(data));

      if (response?.success) {
        getDate();
        // setcateDetailAdd({
        //   type: "",
        //   number: "",
        //   area: "",
        //   lengths: "",
        //   widths: "",
        // });
        // dispatch(adminAction.getRoleList('dhsg'))
        setAddModalOpen7(false);
      }
      // dispatch(
      //   allapiAction.subcreateCategory({
      //     name: cateDetailAdd?.name,

      //     meta_title: cateDetailAdd?.meta_title,
      //     meta_description: cateDetailAdd?.meta_description,
      //     admin_commisstion: cateDetailAdd?.admin_commisstion,
      //     parentId: selectedOption?._id,
      //   })
      // );

      return () => {};
    }
  };
  const handleOk = () => {
    const data = new FormData();
    data.append("name", cateDetail?.name);
    // data.append('description', categoryUpPage)
    data.append("meta_title", cateDetail?.meta_title);
    data.append("meta_description", cateDetail?.meta_description);
    data.append("cate_id", cateDetail?._id);
    data.append("parentId", selectedOptionUpdate?._id);
    data.append("admin_commisstion", cateDetail?.admin_commisstion);
    data.append("pageNo", page);
    if (Imagesfe[0]?.file) {
      // roledata?.role_name
      data.append("image", Imagesfe[0]?.file);
    }
    dispatch(allapiAction.updateperentsubCate(data));
    // dispatch(
    //   allapiAction.updateperentsubCate({
    //     name: cateDetail?.name,
    //     // description: categoryUpPage,
    //     meta_title: cateDetail?.meta_title,
    //     meta_description: cateDetail?.meta_description,
    //     admin_commisstion: cateDetail?.admin_commisstion,
    //     parentId: selectedOptionUpdate?._id,
    //     pageNo: page,
    //     cate_id: cateDetail?._id,
    //   })
    // );
    // dispatch(adminAction.getRoleList('dhsg'))
    setIsModalOpen(false);
    return () => {};
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const [cateDetail2, setcateDetail2] = useState({});
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [cateDetail2s, setcateDetail2s] = useState({});
  const handleOkAdd3 = async () => {
    if (!cateDetail3?.name) {
      toast.error("please enter name");
    } else if (!cateDetail3?.loaction) {
      toast.error("please enter loaction");
    } else {
      const data = new FormData();
      data.append("page", 1);
      data.append("name", cateDetail3?.name);
      // data.append('description', aboutPage)
      // data.append("meta_title", cateDetail3?.meta_title);
      // data.append("meta_description", cateDetail3?.meta_description);
      data.append("_id", cateDetail3?._id);
      data.append("loaction", cateDetail3?.loaction);
      data.append("khasranumber", cateDetail3?.khasranumber);
      data.append("sanyojakName", cateDetail3?.sanyojakName);
      data.append("vyavsthapakName", cateDetail3?.vyavsthapakName);
      data.append("kashtkarName", cateDetail3?.kashtkarName);
      data.append("areaBigha", cateDetail3?.areaBigha);
      data.append("schemerate", cateDetail3?.schemerate);
      data.append("developmentCharges", cateDetail3?.developmentCharges);
      data.append("shopRate", cateDetail3?.shopRate);
      data.append("totalPlotArea", cateDetail3?.totalPlotArea);
      data.append("totalRoadArea", cateDetail3?.totalRoadArea);
      // data.append("RegDate", startDate.toISOString().split("T")[0]);
      // data.append('categoryName', 'test cate')
      data.append("parentId", "11");
      data.append("sellerId", "20");
      // data.append("image", images[0]?.file);

      await dispatch(allapiAction.updateScheme(data));
      getDate();
      setcateDetailAdd({
        name: "",
        loaction: "",
        khasranumber: "",
        sanyojakName: "",
        vyavsthapakName: "",
        kashtkarName: "",
        areaBigha: "",
      });
      // dispatch(adminAction.getRoleList('dhsg'))
      setAddModalOpen3(false);
      return () => {};
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [cateDetailAdd, setcateDetailAdd] = useState({});
  console.log(cateDetailAdd);

  const hendleTochangeCategoryAdd = (e) => {
    const { name, value } = e.target;
    console.log(name);

    if (name == "lengths") {
      const area = (cateDetailAdd?.widths * value) / 9;
      console.log(area);

      setcateDetailAdd((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else if (name == "widths") {
      const area = (cateDetailAdd?.lengths * value) / 9;
      setcateDetailAdd((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else {
      setcateDetailAdd({ ...cateDetailAdd, [name]: value });
    }
  };

  const showModalAdd = (e) => {
    console.log(e);
    setcateDetail(e);
    setAddModalOpen(true);
  };
  const showModalAdd1 = (e) => {
    console.log(e);
    setcateDetail1(e);
    setAddModalOpen1(true);
  };
  const showModalAdd2 = (e) => {
    console.log(e);
    setcateDetail1(e);
    setAddModalOpen2(true);
  };
  const showModalAdd7 = (e) => {
    console.log(e);
    setcateDetail1(e);
    setAddModalOpen7(true);
  };
  const showModalAdd3 = (e) => {
    console.log(e);
    setcateDetail3(e);
    setAddModalOpen3(true);
  };

  const [aboutPage, setaboutPage] = useState("");
  const handleOkAdd = async () => {
    if (!cateDetailAdd?.type) {
      toast.error("please enter type");
    } else if (!cateDetailAdd?.number) {
      toast.error("please enter number");
    } else if (!cateDetailAdd?.area) {
      toast.error("please enter area");
    } else {
      const data = new FormData();
      // data.append("page", 1);
      // data.append("name", cateDetailAdd?.name);
      // // data.append('description', aboutPage)
      // data.append("meta_title", cateDetailAdd?.meta_title);
      // data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append("categoryName", "test cate");
      // data.append("parentId", selectedOption?._id);
      // data.append("sellerId", "20");
      // data.append("image", images[0]?.file);
      if (cateDetailAdd?.lengths) {
        cateDetailAdd.lengthWidth =
          cateDetailAdd?.lengths + "x" + cateDetailAdd?.widths;
      }

      cateDetailAdd.schemeId = id;

      const response = await dispatch(allapiAction.createPlot(cateDetailAdd));
      if (selectedFile?.length > 0) {
        for (let i = 0; i < selectedFile?.length; i++) {
          data.append("images", selectedFile[i]);
        }
        data.append("propertyId", response?.data?._id);
        // data.append("schemeId", id);
        const response1 = await dispatch(
          allapiAction.propertyDocumentAdd(data)
        );
      }

      if (response?.success) {
        getDate();
        setSelectedFile(null);
        setcateDetailAdd({
          type: "",
          number: "",
          area: "",
          lengths: "",
          widths: "",
        });
        // dispatch(adminAction.getRoleList('dhsg'))
        setAddModalOpen(false);
      }
      // dispatch(
      //   allapiAction.subcreateCategory({
      //     name: cateDetailAdd?.name,

      //     meta_title: cateDetailAdd?.meta_title,
      //     meta_description: cateDetailAdd?.meta_description,
      //     admin_commisstion: cateDetailAdd?.admin_commisstion,
      //     parentId: selectedOption?._id,
      //   })
      // );

      return () => {};
    }
  };

  const handleCancelAdd = () => {
    setAddModalOpen(false);
  };
  const handleCancelAdd1 = () => {
    setAddModalOpen1(false);
  };

  const handleCancelAdd2 = () => {
    setAddModalOpen2(false);
  };
  const handleCancelAdd7 = () => {
    setAddModalOpen7(false);
  };
  const handleCancelAdd3 = () => {
    setAddModalOpen3(false);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };
  const showDeleteConfirm8 = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete8(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusSubCategory({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //       <div style={{width:"100px"}}>
    //         <img  style={{width:"100%"}} src={URL?.API_BASE_URL +item?.image} alt="" />
    //       </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "100px" }}>
              <img
                style={{ width: "100%" }}
                src={URL?.API_BASE_URL + item?.image}
                alt=""
              />
            </div>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      className: "table_action_col",
    },
    {
      title: "admin commisstion",
      dataIndex: "admin_commisstion",
      key: "admin_commisstion",
      className: "table_action_col",
    },

    {
      title: "Perent Category",
      dataIndex: "parentId",
      key: "parentId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.parentId?.name}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title={item?.status}>
              <button
                className={
                  item?.is_status == "Active"
                    ? "success-button ml-3"
                    : "delete-button ml-3"
                }
                onClick={() =>
                  hendleToStatus(
                    item?._id,
                    item?.is_status == "Active" ? "Inactive" : "Active"
                  )
                }
              >
                {item?.is_status}
              </button>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                                hendleModalShow(item?.id)
                              }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    // dispatch(allapiAction.getsubCategoryList(1));
    // dispatch(allapiAction.getcateAllList({}));
    getDate();
    return () => {};
  }, []);

  const [details, setdetails] = useState({});

  console.log(details);

  const getDate = async () => {
    const response = await dispatch(allapiAction.getSchemeDetails(id));

    if (response?.success) {
      setdetails(response?.data);
    }
  };

  // const [page, setPage] = useState(1);
  const [search, setsearch] = useState("");
  const handleChange = (e) => {
    console.log(e);
    setsearch(e);
    setPage(1);
    if (e) {
      dispatch(allapiAction.allcategorySearch({ page: 1, search: e }));
      return () => {};
    } else {
      dispatch(allapiAction.getsubCategoryList(1));

      return () => {};
    }
    // getuserListSearch
    // &user_id=${data?.user_id}&search=${data?.user_id}
  };

  const hendlePahegi = (e) => {
    setPage(e);
    if (search) {
      dispatch(allapiAction.allcategorySearch({ page: e, search: search }));
      return () => {};
    } else {
      dispatch(allapiAction.getsubCategoryList(e));

      return () => {};
    }
  };

  const fshop = details?.Shops ? details?.Shops : [];
  const fplot = details?.Plots ? details?.Plots : [];

  console.log(fplot);

  const totalPlatArea = fplot.reduce((acc, item) => {
    return acc + item?.area;
  }, 0);
  console.log(totalPlatArea);

  const finalshop2 = fshop.sort((a, b) => {
    console.log(a.number, b.number);
    const getTypeAndNumber = (str) => {
      if (/^[0-9]+$/.test(str)) {
        return { type: "number", num: parseInt(str) };
      } else if (/^A-/i.test(str)) {
        return { type: "A", num: parseInt(str.split("-")[1]) };
      } else if (/^B-/i.test(str)) {
        return { type: "B", num: parseInt(str.split("-")[1]) };
      } else if (/^[0-9]+\/[0-9]+$/.test(str)) {
        // Fractions like "45/56"
        const parts = str.split("/");
        return { type: "number", num: parseInt(parts[0]) };
      }
      return { type: "other", num: 0 }; // For unexpected cases
    };

    const valA = getTypeAndNumber(a.number);
    const valB = getTypeAndNumber(b.number);
    console.log(valA, valB);
    // Sort by type first: number < A < B
    if (valA.type !== valB.type) {
      const typeOrder = { number: 1, A: 2, B: 3 };
      return typeOrder[valA.type] - typeOrder[valB.type];
    }

    // If types are the same, sort by numeric value
    return valA.num - valB.num; // Sort by numeric value
  });

  const finalshop = fshop.sort((a, b) => {
    console.log(a.number, b.number);

    const getTypeAndNumber = (str) => {
      // Pure numbers
      if (/^[0-9]+$/.test(str)) {
        return { type: "number", num: parseInt(str) };
      }

      // Fractions like "45/56"
      if (/^[0-9]+\/[0-9]+$/.test(str)) {
        const parts = str.split("/");
        return { type: "number", num: parseInt(parts[0]) };
      }

      // Handles cases like "12A" or "45B"
      if (/^[0-9]+[A-Z]$/i.test(str)) {
        const num = parseInt(str.match(/^[0-9]+/)[0]); // Extract number
        const suffix = str.match(/[A-Z]$/i)[0]; // Extract suffix
        return { type: "suffix", num, suffix };
      }

      // "A-" or "B-" prefix
      if (/^A-/i.test(str)) {
        return { type: "A", num: parseInt(str.split("-")[1]) };
      }
      if (/^B-/i.test(str)) {
        return { type: "B", num: parseInt(str.split("-")[1]) };
      }

      // Default case for unexpected inputs
      return { type: "other", num: 0 };
    };

    const valA = getTypeAndNumber(a.number);
    const valB = getTypeAndNumber(b.number);
    console.log(valA, valB);

    // Sort by type first: number < suffix < A < B
    if (valA.type !== valB.type) {
      const typeOrder = { number: 1, suffix: 2, A: 3, B: 4 };
      return typeOrder[valA.type] - typeOrder[valB.type];
    }

    // If types are the same, sort by numeric value
    if (valA.num !== valB.num) {
      return valA.num - valB.num;
    }

    // If numeric values are the same, sort by suffix alphabetically
    if (valA.suffix && valB.suffix) {
      return valA.suffix.localeCompare(valB.suffix);
    }

    return 0; // For cases where everything is identical
  });
  const finalplot = fplot.sort((a, b) => {
    console.log(a.number, b.number);

    const getTypeAndNumber = (str) => {
      // Pure numbers
      if (/^[0-9]+$/.test(str)) {
        return { type: "number", num: parseInt(str) };
      }

      // Fractions like "45/56"
      if (/^[0-9]+\/[0-9]+$/.test(str)) {
        const parts = str.split("/");
        return { type: "number", num: parseInt(parts[0]) };
      }

      // Handles cases like "12A" or "45B"
      if (/^[0-9]+[A-Z]$/i.test(str)) {
        const num = parseInt(str.match(/^[0-9]+/)[0]); // Extract number
        const suffix = str.match(/[A-Z]$/i)[0]; // Extract suffix
        return { type: "suffix", num, suffix };
      }

      // "A-" or "B-" prefix
      if (/^A-/i.test(str)) {
        return { type: "A", num: parseInt(str.split("-")[1]) };
      }
      if (/^B-/i.test(str)) {
        return { type: "B", num: parseInt(str.split("-")[1]) };
      }

      // Default case for unexpected inputs
      return { type: "other", num: 0 };
    };

    const valA = getTypeAndNumber(a.number);
    const valB = getTypeAndNumber(b.number);
    console.log(valA, valB);

    // Sort by type first: number < suffix < A < B
    if (valA.type !== valB.type) {
      const typeOrder = { number: 1, suffix: 2, A: 3, B: 4 };
      return typeOrder[valA.type] - typeOrder[valB.type];
    }

    // If types are the same, sort by numeric value
    if (valA.num !== valB.num) {
      return valA.num - valB.num;
    }

    // If numeric values are the same, sort by suffix alphabetically
    if (valA.suffix && valB.suffix) {
      return valA.suffix.localeCompare(valB.suffix);
    }

    return 0; // For cases where everything is identical
  });
  const finalplots = fplot.sort((a, b) => {
    const getTypeAndNumber2 = (str) => {
      if (/^[0-9]+$/.test(str)) {
        return { type: "number", num: parseInt(str) };
      } else if (/^A-/i.test(str)) {
        return { type: "A", num: parseInt(str.split("-")[1]) };
      } else if (/^B-/i.test(str)) {
        return { type: "B", num: parseInt(str.split("-")[1]) };
      } else if (/^[0-9]+\/[0-9]+$/.test(str)) {
        // Fractions like "45/56"
        const parts = str.split("/");
        return { type: "number", num: parseInt(parts[0]) };
      } else if (/^[0-9]+[A-Z]$/i.test(str)) {
        // Fractions like "45/56"
        const num = parseInt(str.match(/^[0-9]+/)[0]); // Extract number
        const suffix = str.match(/[A-Z]$/i)[0];
        // return { type: "number", num: parseInt(parts[0])  };
        return { type: "suffix", num, suffix };
      }
      return { type: "other", num: 0 }; // For unexpected cases
    };

    const valA = getTypeAndNumber2(a.number);
    const valB = getTypeAndNumber2(b.number);

    // Sort by type first: number < A < B
    if (valA.type !== valB.type) {
      const typeOrder = { number: 1, A: 2, B: 3 };
      return typeOrder[valA.type] - typeOrder[valB.type];
    }

    // If types are the same, sort by numeric value
    return valA.num - valB.num;
  });

  const soldShop = finalshop.filter((data) => data?.fullName);
  const soldPlot = finalplot.filter((data) => data?.fullName);
  const unsoldShop = finalshop.filter((data) => !data?.fullName);
  const unsoldPlot = finalplot.filter((data) => !data?.fullName);

  const totalsoldPlatArea = soldPlot.reduce((acc, item) => {
    return acc + item?.area;
  }, 0);
  console.log(totalsoldPlatArea);

  const [filter, setFilter] = useState("all");
  const finalplot1 =
    filter == "all" ? finalplot : filter == "unsold" ? unsoldPlot : soldPlot;
  const finalshop1 =
    filter == "all" ? finalshop : filter == "unsold" ? unsoldShop : soldShop;
  const downloadProPerty = async () => {
    const token = localStorage.getItem("admin_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const formData = {};
    const response = await Api.post(
      `${URL.getcateAllProperty}`,
      formData,
      config
    );
    const data = response.data?.data;

    if (data.length === 0) {
      // toast.error("No Schemes found");
    } else {
      let schemes = data.map((item, i) => {
        return {
          ["Sr. No. "]: i + 1,
          ["Onwer Name"]: item?.fullName,
          ["Father's/Husband's Name"]: item?.fatharYaHusband,
          ["Scheme Name"]: item?.skimName,
          ["Address"]: item?.Address,
          ["Area"]: item?.area,
          ["Plot/Shop No."]: item?.number,
          ["Type"]: item?.type,
          ["Sold"]: item?.sold,
          ["Recept No."]: item?.rasidNo,

          ["Sale Date"]: item?.sellinDate
            ? moment(item?.sellinDate).format(" DD/MM/YYYY ")
            : "",
          ["Transafard"]: item?.transferred,
        };
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(schemes);

      const colWidths = Object.keys(schemes[0]).map((key) => {
        const maxContentLength = Math.max(
          key.length,
          ...schemes.map((scheme) =>
            scheme[key] ? scheme[key].toString().length : 0
          )
        );
        return { width: maxContentLength + 2 }; // Adding 2 for padding
      });

      worksheet["!cols"] = colWidths;
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "property.xlsx");
    }
  };
  const downloadProPertyr = async () => {
    const token = localStorage.getItem("admin_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const formData = {};
    if (id) {
      formData.schemeId = id;
    }
    const response = await Api.post(
      `${URL.getcateAllProperty}`,
      formData,
      config
    );
    const data = response.data?.data;

    if (data.length === 0) {
      // toast.error("No Schemes found");
    } else {
      let schemes = data.map((item, i) => {
        return {
          ["Sr. No. "]: i + 1,
          ["Onwer Name"]: item?.fullName,
          ["Father's/Husband's Name"]: item?.fatharYaHusband,
          ["Scheme Name"]: item?.skimName,
          ["Address"]: item?.Address,
          ["Area"]: item?.area,
          ["Plot/Shop No."]: item?.number,
          ["Type"]: item?.type,
          ["Sold"]: item?.sold,
          ["Recept No."]: item?.rasidNo,

          ["Sale Date"]: item?.sellinDate
            ? moment(item?.sellinDate).format(" DD/MM/YYYY ")
            : "",
          ["Transafard"]: item?.transferred,
        };
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(schemes);

      const colWidths = Object.keys(schemes[0]).map((key) => {
        const maxContentLength = Math.max(
          key.length,
          ...schemes.map((scheme) =>
            scheme[key] ? scheme[key].toString().length : 0
          )
        );
        return { width: maxContentLength + 2 }; // Adding 2 for padding
      });

      worksheet["!cols"] = colWidths;
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "property.xlsx");
    }
  };

  const hendleTochangefiles = (e) => {
    const { name, files } = e.target;

    setSelectedFile(files);
    setcateDetail2({ ...cateDetail2, [name]: files });
  };
  const hendleTochangefiless = (e) => {
    const { name, files } = e.target;

    setSelectedFiles(files);
    setcateDetail2s({ ...cateDetail2s, [name]: files });
  };

  const [addModalOpen6, setAddModalOpen6] = useState(false);
  const [addModalOpen5, setAddModalOpen5] = useState(false);
  const handleCancelAdd6 = () => {
    setAddModalOpen6(false);
  };
  const componentRef = useRef();
  const handleCancelAdd5 = () => {
    setAddModalOpen5(false);
  };
  return (
    <div>
      {/* update */}
      <Modal
        title="Update Category"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <ImageUploading
            // multiple
            value={Imagesfe}
            onChange={onChangefe}
            maxNumber={maxNumber}
            dataURLKey="data_url"
            acceptType={["png", "jpeg", "jpg", "webp"]}
            // acceptType={['jpg']}
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">
                <button
                  style={isDragging ? { color: "red" } : {}}
                  onClick={onImageUpload}
                  {...dragProps}
                  className="btn btn-secondary"
                >
                  Choose image
                </button>
                &nbsp;
                {/* <button
                  className="btn btn-secondary"
                  onClick={onImageRemoveAll}
                >
                  Remove all images
                </button> */}
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.data_url} alt="" width="100" />
                    <div className="image-item__btn-wrapper">
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageUpdate(index)}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageRemove(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Select
            value={selectedOptionUpdate}
            onChange={setSelectedOptionUpdate}
            options={subList}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="name"
            name="name"
            value={cateDetail?.name}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="admin commisstion"
            name="admin_commisstion"
            value={cateDetail?.admin_commisstion}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta title"
            name="meta_title"
            value={cateDetail?.meta_title}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>

        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta description"
            name="meta_description"
            value={cateDetail?.meta_description}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
      </Modal>

      {/* create */}
      <Modal
        title="Create Plot/shop"
        open={addModalOpen}
        onOk={handleOkAdd}
        onCancel={handleCancelAdd}
      >
        <Row>
          {/* <Col lg={24} md={24} sm={24} xs={24}>
          <Select
            value={selectedOption}
            onChange={setSelectedOption}
            options={subList}
          />
        </Col> */}
          <Col lg={24} md={24} sm={24} xs={24}>
            Please Choose
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <select
              className="form-control mt-8"
              name="type"
              value={cateDetailAdd?.type}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            >
              <option value="">Choose</option>
              <option value="Shop">Shop</option>
              <option value="Plot">Plot</option>
            </select>
            {/* <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="name"
              name="name"
              value={cateDetailAdd?.name}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            /> */}
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            Plot/Shop No.
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="number"
              name="number"
              value={cateDetailAdd?.number}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            L X W Feet
          </Col>
          <Col lg={11} md={11} sm={11} xs={11}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="length"
              name="lengths"
              type="number"
              value={cateDetailAdd?.lengths}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>{" "}
          <Col lg={2} md={2} sm={2} xs={2}>
            <div className="pt-15 text-center">
              <span>X</span>
            </div>
          </Col>
          <Col lg={11} md={11} sm={11} xs={11}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="width"
              name="widths"
              type="number"
              value={cateDetailAdd?.widths}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            Area (Sq. Gaj)
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder=" area"
              name="area"
              type="number"
              value={cateDetailAdd?.area}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Select Document</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="images"
              name="images"
              type="file"
              accept="image/*"
              multiple
              // value={cateDetailAdd?.fullName}
              onChange={(e) => {
                hendleTochangefiles(e);
              }}
            />
          </Col>
        </Row>
      </Modal>
      {/* belence Sheet */}
      <Modal
        title="Scheme Balance Sheet"
        open={addModalOpen1}
        onOk={handleCancelAdd1}
        onCancel={handleCancelAdd1}
      >
        <Row className="balanceSheet">
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Scheme Name :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.name}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Location :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.loaction}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Registration Date :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.RegDate}
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Scheme Area :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.areaBigha} Bigha
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Scheme Rate :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.schemerate} Rs./Bigha
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Development Charges :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.developmentCharges} Rs.
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
                marginTop: "10px",
                marginBottom: "0px",
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Scheme Value :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            0 Rs.
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
                marginBottom: "10px",
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Plots :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {fplot?.length}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Plots Area:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {totalPlatArea?.toFixed(2)} Sq. Gaj
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Shop:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {fshop?.length}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Plot Rate (per Sq. Gaj):</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            0 Rs.
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Shop Rate (per shop):</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            0 Rs.
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Sold Plots:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {soldPlot?.length}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Sold Shop:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {soldShop?.length}
          </Col>

          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Sold Plot Area :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {totalsoldPlatArea?.toFixed(2)} Sq. Gaj
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Plot Amount :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            0 Rs.
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Shop Amount :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            0 Rs.
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Amount :</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            0 Rs.
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
              }}
            />
          </Col>
        </Row>
      </Modal>
      {/* Details */}
      <Modal
        title="Scheme Details"
        open={addModalOpen2}
        onOk={handleCancelAdd2}
        onCancel={handleCancelAdd2}
        width={700}
      >
        <Row className="balanceSheet">
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5  "> General </div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Name :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.name}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Location :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.loaction}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Khasra Number :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.khasranumber}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Sanyojak Name :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.sanyojakName}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  "> Kashtkar(s) Name :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.kashtkarName}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Vyavsthapak Name :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.vyavsthapakName}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Reg. Date :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.RegDate}
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5  ">Figures:</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Scheme Area :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.areaBigha} Bigha
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Scheme Rate :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.schemerate} Rs./Bigha
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Development Charges :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {details?.Scheme?.developmentCharges} Rs.
          </Col>
          {/* <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
                marginTop: "10px",
                marginBottom: "0px",
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col> */}
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Scheme Value :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            0 Rs.
          </Col>
          {/* <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
                marginBottom: "10px",
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col> */}
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Shop Rate (per shop):</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            0 Rs.
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Road Area:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {details?.Scheme?.totalRoadArea} Sq. Gaj
          </Col>

          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Plot Rate (per Sq. Gaj):</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            0 Rs.
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Plots Area:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {totalPlatArea?.toFixed(2)} Sq. Gaj
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Plots :</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {fplot?.length}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Shop:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {fshop?.length}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Sold Plots:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {soldPlot?.length}
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Sold Shop:</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            {soldShop?.length}
          </Col>

          {/* <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Sold Plot Area :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            {totalsoldPlatArea?.toFixed(2)} Sq. Gaj
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Plot Amount :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            0 Rs.
          </Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Shop Amount :</div>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            0 Rs.
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col>
          <Col lg={7} md={7} sm={7} xs={7}>
            <div className="text-end mr-5  ">Total Amount :</div>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5}>
            0 Rs.
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}></Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <hr
              style={{
                margin: "0px",
                height: "2px",
                background: "#ffffff",
                opacity: "1",
              }}
            />
          </Col> */}
        </Row>
      </Modal>

      {/* edit  */}
      <Modal
        title="Edit New Scheme"
        open={addModalOpen3}
        onOk={handleOkAdd3}
        onCancel={handleCancelAdd3}
        width={900}
      >
        <Row>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Scheme Name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="name"
              name="name"
              value={cateDetail3?.name}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Loaction</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="loaction"
              name="loaction"
              value={cateDetail3?.loaction}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Khasra number</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="khasranumber"
              name="khasranumber"
              value={cateDetail3?.khasranumber}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Sanyojak name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Sanyojak name"
              name="sanyojakName"
              value={cateDetail3?.sanyojakName}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Vyavsthapak name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="vyavsthapak name"
              name="vyavsthapakName"
              value={cateDetail3?.vyavsthapakName}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Kashtkar name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="kashtkar name"
              name="kashtkarName"
              value={cateDetail3?.kashtkarName}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          {/* <Col lg={6} md={6} sm={6} xs={6}>
          
            <div className="text-end mr-5 mt-15">Area (Bigha)</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="area bigha"
              name="areaBigha"
              value={cateDetailAdd?.areaBigha}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col> */}
          {/* <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15"> Reg. Date</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <DatePicker
              className="form-control mt-5"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
            />
          </Col> */}

          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Scheme Area (Bigha)</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="area bigha"
              name="areaBigha"
              value={cateDetail3?.areaBigha}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Scheme Rate</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Scheme rate"
              name="schemerate"
              type="number"
              value={cateDetail3?.schemerate}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Development Charges</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Development Charges"
              name="developmentCharges"
              type="number"
              value={cateDetail3?.developmentCharges}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Shop Rate</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Shop Rate"
              name="shopRate"
              type="number"
              value={cateDetail3?.shopRate}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Total Plot Area</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Total Plot Area"
              name="totalPlotArea"
              type="number"
              value={cateDetail3?.totalPlotArea}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Total Raod Area</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Total Road Area"
              name="totalRoadArea"
              type="number"
              value={cateDetail3?.totalRoadArea}
              onChange={(e) => {
                hendleTochangeCategory3(e);
              }}
            />
          </Col>
        </Row>
      </Modal>
      {/* document  */}

      <Modal
        className="plotDetailsMd"
        title="Add Document"
        open={addModalOpen7}
        onOk={handleOkAddDocument}
        onCancel={handleCancelAdd7}
        width={800}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Select Document</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="images"
              name="images"
              type="file"
              accept="image/*"
              multiple
              // value={cateDetailAdd?.fullName}
              onChange={(e) => {
                hendleTochangefiless(e);
              }}
            />
          </Col>
        </Row>
      </Modal>
      <Modal
        className="plotDetailsMd"
        title="View Document"
        open={addModalOpen6}
        onOk={handleCancelAdd6}
        onCancel={handleCancelAdd6}
        width={800}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            {details?.documents &&
              details?.documents?.map((data, i) => {
                return (
                  <div className=" mr-5 mt-15">
                    {data?.type == "pdf" ? (
                      <div style={{ height: "500px" }}>
                        <Tooltip title="Delete">
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              showDeleteConfirm(data?._id);
                            }}
                          >
                            <SvgIcon.deletebtn className="scale-icon edit-icon" />
                          </span>
                        </Tooltip>
                        <iframe
                          src={URL.API_BASE_URL + data?.document}
                          width="100%"
                          height="100%"
                          title="PDF Viewer"
                          style={{ border: "none" }}
                        />
                      </div>
                    ) : (
                      <div>
                        {" "}
                        <Tooltip title="Delete">
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              showDeleteConfirm(data?._id);
                            }}
                          >
                            <SvgIcon.deletebtn className="scale-icon edit-icon" />
                          </span>
                        </Tooltip>
                        <img
                          src={URL.API_BASE_URL + data?.document}
                          alt=""
                          style={{ width: "100%" }}
                        />
                        {/* <a
                          href={URL.API_BASE_URL + data?.document}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                          style={{
                            marginTop: "10px",
                            background: "#f5f5f5",
                            padding: "5px",
                          }}
                        >
                          Download
                          
                        </a> */}
                      </div>
                    )}
                    {/* Select Document */}
                  </div>
                );
              })}
          </Col>
        </Row>
      </Modal>
      <Modal
        className="plotDetailsMd"
        title="Print Document"
        open={addModalOpen5}
        onOk={handleCancelAdd5}
        onCancel={handleCancelAdd5}
        width={800}
      >
        <Row ref={componentRef}>
          <Col lg={24} md={24} sm={24} xs={24}>
            {details?.documents &&
              details?.documents?.map((data, i) => {
                return (
                  <div className=" mr-5 mt-15">
                    {data?.type == "pdf" ? (
                      <div style={{ height: "500px" }}>
                        <iframe
                          src={URL.API_BASE_URL + data?.document}
                          width="100%"
                          height="100%"
                          title="PDF Viewer"
                          style={{ border: "none" }}
                        />
                      </div>
                    ) : (
                      <div>
                        {/* <Tooltip title="Delete">
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              showDeleteConfirm(data?._id);
                            }}
                          >
                            <SvgIcon.deletebtn className="scale-icon edit-icon" />
                          </span>
                        </Tooltip> */}
                        <img
                          src={URL.API_BASE_URL + data?.document}
                          alt=""
                          style={{ width: "100%" }}
                        />

                        {/* <a
                          href={URL.API_BASE_URL + data?.document}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                          style={{
                            marginTop: "10px",
                            background: "#f5f5f5",
                            padding: "5px",
                          }}
                        >
                          Download
                          
                        </a> */}
                      </div>
                    )}
                    {/* Select Document */}
                  </div>
                );
              })}
          </Col>
        </Row>
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6">
            <ReactToPrint
              trigger={() => (
                <Button variant="primary">Print / Download</Button>
              )}
              content={() => componentRef.current}
            />
          </div>
        </div>
      </Modal>
      <div className="flex">
        <div>
          <HeadingBack
            title={"Scheme Details"}
            // subHeading={`Total ${users_list?.totalDocs || 0} Scheme Details`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          {/* <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          /> */}
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        <div className="flex1 flex justify-content-end align-items-center">
          {/* <Tooltip title="Add">
            <span className="jop_btn" onClick={() => showModalAdd()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip> */}
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <div className="container">
          <div className="row">
            <div className="col-6">
              <div className="Shedow">
                <div className="SchecmeDetails">
                  <div className="row">
                    <div className="col-md-8">
                      <p>
                        <span style={{ fontWeight: "bold" }}>Reg. Date</span> :{" "}
                        {details?.Scheme?.RegDate}
                      </p>
                      <p style={{ textTransform: "capitalize" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Scheme Name
                        </span>{" "}
                        : {details?.Scheme?.name}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>Total Shop</span> :{" "}
                        {fshop?.length}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>Total Plot</span> :{" "}
                        {fplot?.length}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>Sold Shop</span> :{" "}
                        {soldShop?.length}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>Sold Plot</span> :{" "}
                        {soldPlot?.length}
                      </p>
                    </div>
                    <div className="col-md-4">
                      <Tooltip title="Download" placement="topLeft">
                        <Button
                          type="primary"
                          icon={<DownloadOutlined />}
                          onClick={downloadProPertyr}
                        >
                          Download Property
                        </Button>
                      </Tooltip>
                      <SchemeWisePdfPlot  details={details}/>
                      <Tooltip title="Add">
                        <span
                          className="jop_btn1"
                          onClick={() => showModalAdd()}
                        >
                          Add Plot/Shop
                        </span>
                      </Tooltip>
                      <Tooltip title="Balance Sheet">
                        <span
                          className="jop_btn1 mt-5"
                          onClick={() => showModalAdd1()}
                        >
                          Balance Sheet
                        </span>
                      </Tooltip>
                      <Tooltip title="Details">
                        <span
                          className="jop_btn1 mt-5"
                          onClick={() => showModalAdd2()}
                        >
                          Scheme Details
                        </span>
                      </Tooltip>
                      <Tooltip title="Edit Scheme">
                        <span
                          className="jop_btn1 mt-5"
                          onClick={() => showModalAdd3(details?.Scheme)}
                        >
                          Edit Scheme
                        </span>
                      </Tooltip>
                      <Tooltip title="Add document">
                        <span
                          className="jop_btn mt-3"
                          onClick={() => showModalAdd7(details)}
                        >
                          Add document
                        </span>
                      </Tooltip>
                      {details?.documents?.length > 0 && (
                        <Tooltip title="View document">
                          <span
                            className="jop_btn mt-3"
                            onClick={() => setAddModalOpen6(true)}
                          >
                            View document
                          </span>
                        </Tooltip>
                      )}
                      {details?.documents?.length > 0 && (
                        <Tooltip title=" Print document">
                          <span
                            className="jop_btn mt-3"
                            onClick={() => setAddModalOpen5(true)}
                          >
                            Print document
                          </span>
                        </Tooltip>
                      )}
                        <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm8(details?.Scheme?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="Shedow">
                <div className="SchecmeDetails">
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <span style={{ fontWeight: "bold" }}>Loaction</span> :{" "}
                        {details?.Scheme?.loaction}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>
                          Khasra number
                        </span>{" "}
                        : {details?.Scheme?.khasranumber}
                      </p>
                      <p style={{ textTransform: "capitalize" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Sanyojak name
                        </span>{" "}
                        : {details?.Scheme?.sanyojakName}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>
                          Vyavsthapak name
                        </span>{" "}
                        : {details?.Scheme?.vyavsthapakName}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>
                          Kashtkar name
                        </span>{" "}
                        : {details?.Scheme?.kashtkarName}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span style={{ fontWeight: "bold" }}>
                          Scheme Area (Bigha)
                        </span>{" "}
                        : {details?.Scheme?.areaBigha}
                      </p>
                      <p style={{ textTransform: "capitalize" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Scheme Rate
                        </span>{" "}
                        : {details?.Scheme?.schemerate}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>
                          Development Charges
                        </span>{" "}
                        : {details?.Scheme?.developmentCharges}
                      </p>
                      <p style={{ textTransform: "capitalize" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Shop Rate
                        </span>{" "}
                        : {details?.Scheme?.shopRate}
                      </p>
                      <p style={{ textTransform: "capitalize" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Total Plot Area
                        </span>{" "}
                        : {details?.Scheme?.totalPlotArea}
                      </p>
                      <p style={{ textTransform: "capitalize" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Total Raod Area
                        </span>{" "}
                        : {details?.Scheme?.totalRoadArea}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div>
            <div className="container">
              <div className="row">
                <div className="col-2">
                  <div className="card p-15">
                    <div className=" justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Filter</h5>
                      <div className=" justify-content-between align-items-center row row-direction-column">
                        <button
                          className={`btn btn-sm mr-2 ${
                            filter === "all" ? "btn-primary" : "btn-light"
                          }`}
                          onClick={() => setFilter("all")}
                        >
                          All
                        </button>
                        <button
                          className={`btn btn-sm mr-2 ${
                            filter === "sold" ? "btn-primary" : "btn-light"
                          }`}
                          onClick={() => setFilter("sold")}
                        >
                          Sold
                        </button>
                        <button
                          className={`btn btn-sm ${
                            filter === "unsold" ? "btn-primary" : "btn-light"
                          }`}
                          onClick={() => setFilter("unsold")}
                        >
                          Unsold
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-10">
                  {" "}
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Shop" key="1">
                      <div className="container">
                        <div className="row">
                          {finalshop1 &&
                            finalshop1?.map((data, i) => {
                              return (
                                <div className="col mt-5">
                                  <div
                                    onClick={() => {
                                      navigate(`/plots-details/${data?._id}`);
                                    }}
                                    style={{
                                      backgroundColor:
                                        data?.transferred == "TRANSFERRED"
                                          ? "#0fff0f"
                                          : data?.fullName
                                          ? "#ff2121"
                                          : "#e1e1e1",
                                      padding: "10px",
                                      textAlign: "center",
                                      minWidth: "80px",
                                    }}
                                  >
                                    <h6 style={{ marginBottom: "0px" }}>
                                      {data?.number}
                                      <p style={{ marginBottom: "0px" }}>
                                        {data?.transferred == "TRANSFERRED"
                                          ? "TRANSFERRED"
                                          : data?.fullName
                                          ? "sold"
                                          : "empty"}
                                      </p>
                                    </h6>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tab="Plots" key="2">
                      <div className="container">
                        <div className="row">
                          {finalplot1 &&
                            finalplot1?.map((data, i) => {
                              return (
                                <div className="col mt-5">
                                  <div
                                    onClick={() => {
                                      navigate(`/plots-details/${data?._id}`);
                                    }}
                                    style={{
                                      backgroundColor:
                                        data?.transferred == "TRANSFERRED"
                                          ? "#0fff0f"
                                          : data?.fullName
                                          ? "#ff2121"
                                          : "#e1e1e1",
                                      padding: "10px",
                                      textAlign: "center",
                                      minWidth: "80px",
                                    }}
                                  >
                                    <h6 style={{ marginBottom: "0px" }}>
                                      {data?.number}
                                      <p style={{ marginBottom: "0px" }}>
                                        {data?.transferred == "TRANSFERRED"
                                          ? "TRANSFERRED"
                                          : data?.fullName
                                          ? "sold"
                                          : "empty"}
                                      </p>
                                    </h6>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>

            <br />
          </div>
        </div>
        {/* <Table
          dataSource={listdata}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: users_list?.totalDocs ? users_list?.totalDocs : 0,
          }}
        /> */}
      </div>
    </div>
  );
}

export default SchemeDetails;
